module.exports = __webpack_public_path__ + "static/img/app.b7af50e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/app.png
// module id = Wtvu
// module chunks = 4